import React, { useRef } from "react";
import { useNode, useEditor } from "@craftjs/core";
import { useSelectLogic } from './hooks/useSelectLogic';
import { useSelectStyles } from './hooks/useSelectStyles';
import { SelectLabel } from './components/SelectLabel';
import { SelectInput } from './components/SelectInput';
import { SelectIcon } from './components/SelectIcon';
import { DEFAULT_PROPS } from './constants/selectConstants';
import { SelectSettings } from './settings/SelectSettings';

export const Select = (props) => {
  const {
    connectors: { connect, drag } = { connect: (ref) => ref, drag: (ref) => ref },
    isSelected = false,
    isHovered = false,
    actions: { setProp } = { setProp: () => {} }
  } = useNode?.((state) => ({
    isSelected: state.events.selected,
    isHovered: state.events.hovered
  })) || {};

  const { enabled = false } = useEditor?.((state) => ({
    enabled: state.options.enabled
  })) || {};

  const selectRef = useRef(null);

  const { currentValue, handleChange, handleBlur } = useSelectLogic({
    value: props.value,
    qwantumId: props.qwantumId,
    onSave: props.onSave,
    setProp,
    enabled,
    allowEditing: props.allowEditing
  });

  const { containerStyle, labelStyle, selectClasses, controlClasses } = useSelectStyles({
    isSelected,
    isHovered,
    enabled,
    ...props
  });

  if (props.hidden) return null;

  return (
    <div 
      ref={ref => enabled ? connect(drag(ref)) : connect(ref)}
      name={props.name}
      className={props.cssClass}
      style={containerStyle}
    >
      <SelectLabel
        labelText={props.labelText}
        showSemicolon={props.showSemicolon}
        style={labelStyle}
      />
      
      <div className={controlClasses}>
        <div className={selectClasses}>
          <SelectInput
            ref={selectRef}
            selectName={props.selectName}
            currentValue={currentValue}
            isMultiple={props.isMultiple}
            multipleSize={props.multipleSize}
            placeholder={props.placeholder}
            options={props.options}
            fontFamily={props.fontFamily}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        <SelectIcon
          hasIcon={props.hasIcon}
          iconPosition={props.iconPosition}
          iconClass={props.iconClass}
        />
      </div>
    </div>
  );
};

Select.craft = {
  props: DEFAULT_PROPS,
  related: {
    settings: SelectSettings
  }
};